import { PIXI } from '@colonist/pixi';
import { UICanvasConfig } from './UICanvasConfig.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { CA } from '../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { isAffectedByFirefoxWebGlBug } from '../ui_utils/ClientUtils.ts';
export class UICanvasController {
    createPIXIApplication(options) {
        this.app = new PIXI.Application({
            autoDensity: true,
            ...options
        });
        this.app.view.id = this.CANVAS_ID;
        this.app.stage.sortableChildren = true;
        var _options_resolution;
        PIXI.settings.RESOLUTION = (_options_resolution = options.resolution) !== null && _options_resolution !== void 0 ? _options_resolution : 2;
        this.registerPixiInspector();
        this.addCanvasWebGLContextLossEventListener();
        this.preventRightClick();
        this.preventMobileTextSelection();
    }
    registerPixiInspector() {
        if (UIUtilsEjsVariables.isProduction) return;
        globalThis.__PIXI_APP__ = this.app;
    }
    setCanvasConfigVariables() {
        UICanvasConfig.setCanvasConfigVariables(this.app);
    }
    get appW() {
        return this.uiCanvasConfig.appWidth;
    }
    get appH() {
        return this.uiCanvasConfig.appHeight;
    }
    get itemSize() {
        return this.uiCanvasConfig.itemSize;
    }
    get margin() {
        return this.uiCanvasConfig.margin;
    }
    updateCanvasSettings(options) {
        const { resolution, antialias, powerPreference } = options;
        if (resolution !== undefined) {
            this.app.renderer.resolution = resolution;
            PIXI.settings.RESOLUTION = resolution;
        }
        if (antialias !== undefined) {
            this.app.renderer.options.antialias = antialias;
        }
        if (powerPreference !== undefined) {
            this.app.renderer.options.powerPreference = powerPreference;
        }
        this.app.renderer.resize(this.appW, this.appH);
        this.app.render();
    }
    addCanvasWebGLContextLossEventListener() {
        let contextLossReported = false;
        this.app.view.addEventListener('webglcontextlost', async (event)=>{
            event.preventDefault();
            if (!contextLossReported) {
                var _window_performance, _window;
                contextLossReported = true;
                const memoryInfo = (_window = window) === null || _window === void 0 ? void 0 : (_window_performance = _window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.memory;
                var _memoryInfo_jsHeapSizeLimit, _memoryInfo_totalJSHeapSize, _memoryInfo_usedJSHeapSize;
                const memoryData = {
                    jsHeapSizeLimit: (_memoryInfo_jsHeapSizeLimit = memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.jsHeapSizeLimit) !== null && _memoryInfo_jsHeapSizeLimit !== void 0 ? _memoryInfo_jsHeapSizeLimit : 0,
                    totalJSHeapSize: (_memoryInfo_totalJSHeapSize = memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.totalJSHeapSize) !== null && _memoryInfo_totalJSHeapSize !== void 0 ? _memoryInfo_totalJSHeapSize : 0,
                    usedJSHeapSize: (_memoryInfo_usedJSHeapSize = memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.usedJSHeapSize) !== null && _memoryInfo_usedJSHeapSize !== void 0 ? _memoryInfo_usedJSHeapSize : 0,
                    isMobile: UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
                    isDiscord: UIUtilsEjsVariables.isUserOnDiscord,
                    powerMode: StorageWrapper.getPowerPreference(),
                    antiAliasing: StorageWrapper.getAntialias(),
                    resolution: StorageWrapper.getResolution(),
                    userAgent: navigator.userAgent
                };
                await CA.sendAnalyticEvent({
                    category: AnalyticEventCategory.WebGL,
                    type: AnalyticEventType.LostWebGLContext,
                    stringValue: JSON.stringify(memoryData)
                });
            }
            let popupBody = UIUtilsEjsVariables.isUserOnDiscord ? 'strings:popups.webglContextLoss.discord' : 'strings:popups.webglContextLoss.body';
            if (!UIUtilsEjsVariables.isUserOnDiscord && isAffectedByFirefoxWebGlBug()) popupBody = 'strings:popups.webglContextLoss.firefox';
            showSimpleDialog({
                title: {
                    key: 'strings:popups.webglContextLoss.title'
                },
                body: {
                    key: popupBody
                }
            });
        });
    }
    preventRightClick() {
        this.app.view.addEventListener('contextmenu', (e)=>e.preventDefault());
    }
    preventMobileTextSelection() {
        this.app.view.addEventListener('selectstart', (e)=>e.preventDefault());
    }
    constructor(){
        this.CANVAS_ID = 'game-canvas';
        this.uiCanvasConfig = UICanvasConfig;
    }
}
